import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { user } from 'services';
import { path } from 'router/sections';
import { updateViolationState } from 'services/reports-service';
import { TableExt, TableInfo, GridBox, GridColumnsSetup } from 'libs/ui';
import { useGridColumns } from 'libs/hooks';
import { getTableParams } from './grid.params';

export const ViolationsGrid = (props) => {
  const { count, count_limit, count_method, getFilter, entries, className, theme, getXlsAction } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const rightEdit = user.haveRight('violations.change_state');

  const showParkingCardAction = (row) => {
    history.push(`${path('stay')}?id=${row.stay_id}`);
  };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const actions = [];
  if (rightEdit) {
    actions.push({
      // isVisible: (row) => row.status !== 'blocked_by_client',
      getTitle: (row) => (!row.is_active ? t('buttons.Активировать') : t('buttons.Архивировать')),
      action: async (row) => {
        await updateViolationState({
          is_active: !row.is_active,
          violation_id: row.id,
        });
        props.refresh(true);
      },
    });
  }
  actions.push({ title: t('buttons.Перейти в карточку парковки'), action: showParkingCardAction, isVisible: (row) => !!row.stay_id });

  // top actions
  const topActions = [];
  if (count) {
    getXlsAction(topActions);
  }

  const tableParams = useMemo(() => getTableParams(t), []);
  const { getFields, fields: staticFields, ...restTableParams } = tableParams;
  const defaultFields = useMemo(() => (getFields ? getFields(props) : staticFields), [getFields, staticFields, props]);
  const { fields, columns, toggleColumn, reorderColumns, resetColumns } = useGridColumns('violations', defaultFields);
  topActions.push({ cmp: <GridColumnsSetup key="columns-setup" columns={columns} onToggle={toggleColumn} onReorder={reorderColumns} onReset={resetColumns} /> });

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} count_limit={count_limit} count_method={count_method} getFilter={getFilter} actions={topActions} />

      <TableExt
        getFilter={getFilter}
        theme={theme}
        title={t('sections.Лог нарушений')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        {...restTableParams}
        fields={fields}
      />
    </GridBox>
  );
};
